import PropTypes from 'prop-types';
import * as React from 'react';

import DatePicker from './DatePicker';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const DateOnlyPicker = (props) => <DatePicker {...props} dateOnly />;

DateOnlyPicker.displayName = 'DateOnlyPicker';

DateOnlyPicker.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

DateOnlyPicker.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
};

export default DateOnlyPicker;
